import React from 'react'
import './App.css'

import Calculadora from './componentes/calculadora/Calculadora'

function App(){
  return(
    <main className = 'container'>
      <Calculadora />
    </main>
  )
}

export default App